<template>
  <div class="card assets-map-form">
    <header class="card-header has-background-dark">
      <p class="card-header-title has-text-light">CREATE ASSET</p>
    </header>
    <div class="card-content scrollable" :style="{ height: `${height}px` }">
      <b-field label="TYPE">
        <b-select v-model="form.type" expanded>
          <option value>Please Select</option>
          <option v-for="type in assetTypes" :value="type.id" :key="type.id">
            {{ type.name }}
          </option>
        </b-select>
      </b-field>
      <b-field label="THIRD PARTY CODE">
        <b-input v-model="form.thirdPartyCode"></b-input>
      </b-field>
      <b-field label="DESCRIPTION">
        <b-input v-model="form.description" type="textarea"></b-input>
      </b-field>

      <b-field label="LATITUDE" v-if="geometryType == 'Point'">
        <b-input v-model="form.latitude" @input="onInputCoords"></b-input>
      </b-field>
      <b-field label="LONGITUDE" v-if="geometryType == 'Point'">
        <b-input v-model="form.longitude" @input="onInputCoords"></b-input>
      </b-field>
    </div>
    <footer class="card-footer">
      <b-button class="is-fullwidth" :loading="loading" @click="create"
        >CREATE</b-button
      >
    </footer>
  </div>
</template>

<script>
export default {
  props: {
    mapHeight: {
      type: Number,
      default: 500,
    },
    assetTypes: {
      type: Array,
      default: () => [],
    },
    loading: {
      type: Boolean,
      default: false,
    },
    geometryType: {
      type: String,
    },
    coordinates: {
      type: Object,
      default: () => ({}),
    },
  },
  data: () => ({
    form: {
      orderType: "",
      type: "",
      thirdPartyCode: "",
      description: "",
      latitude: "",
      longitude: "",
    }
  }),
  computed: {
    height() {
      return this.mapHeight - 70.844 - 73.781; // Card header height, Card footer height
    }
  },
  watch: {
    coordinates() {
      this.form.latitude = this.coordinates.latitude;
      this.form.longitude = this.coordinates.longitude;
    },
  },
  methods: {
    create() {
      this.$emit("create", this.form);
    },
    onInputCoords: _.debounce(function () {
      let coords = null;
      const latitude = parseFloat(this.form.latitude);
      const longitude = parseFloat(this.form.longitude);
      if (!isNaN(this.form.latitude) && !isNaN(this.form.longitude)) {
        coords = {
          latitude,
          longitude,
        };
      }
      this.$emit("input-coordinates", coords);
    }, 500),
  }
};
</script>



// WEBPACK FOOTER //
// src/components/AssetsOfflineMapForm.vue